
































































































































































































import Component from "vue-class-component";
import ViewList from "@/views/List.vue";
import _, {isEmpty} from "lodash";
import {Getter, Action} from "vuex-class";
import SocleList from "@/components/socle/list/List.vue";
import SocleLightList from "@/components/socle/list/ListLight.vue";
import SocleCampaignForm from "@/components/forms/socle/CampaignForm.vue";
import SocleValidationBudgetForm from "@/components/forms/socle/ValidationBudgetForm.vue";
import SocleCampaignLightForm from "@/components/forms/socle/light/CampaignLightForm.vue";
import SocleCampaignLightLeversForm from "@/components/forms/socle/light/CampaignLightLeversForm.vue";
import SocleValidationBudgetLightForm from "@/components/forms/socle/light/ValidationBudgetLightForm.vue";
import BudgetRepository from "@/repositories/socle/BudgetRepository";
import * as Constants from "@/Constants";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import SelectGroupSearch from "@/components/forms/search/SelectGroupSearch.vue";
import {Watch} from "vue-property-decorator";
import DatePickerSearch from "@/components/forms/search/DatePickerSearch.vue";
import MultipleSelectSearch from "@/components/forms/search/MultipleSelectSearch.vue";
import EventBus from "front-component/EventBus";
import moment from "moment";
import Http from "front-component/Http";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import {OptionOwner} from "@/mixins/components/CommonSelectOwnerMixin";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";
import SelectMultipleOwner from "@/components/owner/SelectMultipleOwner.vue";
import {Filters, SocleFilters} from "@/modules/SocleFilters";
import FileRepository, {Document} from "@/repositories/FileRepository";
import {SocleClient} from "@/modules/Socle";
import CsTreeSelect from "@/components/miscellaneous/CsTreeSelect.vue";
import {fileType} from "@/Constants";

const components = {
    SocleList,
    SocleLightList,
    SocleCampaignForm,
    SocleCampaignLightForm,
    SocleCampaignLightLeversForm,
    SelectSearch,
    SelectGroupSearch,
    SocleValidationBudgetForm,
    SocleValidationBudgetLightForm,
    MultipleSelectSearch,
    DatePickerSearch,
    SelectOwner,
    SelectMultipleOwner,
    KeywordSearch,
    CsTreeSelect,
};

interface Node {
  id: string;
  label: string;
  children?: Node[];
}

@Component({components})
export default class List extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("getSocleFilters") public filters!: Filters;
    @Action("updateSocleFilters") public updateFilter!: (filters: Filters) => void;
    @Action("initializeSocleFilters") public initializeSocleFilters!: (filters: object | null) => void;
    @Getter("getSocleClient") public configSocleData!: SocleClient;

    private currentSocleCampagneUuid: string | null = null;
    private currentSocleBundleUuid: string | null = null;
    private formVisible: boolean = false;
    private currentYear: number = new Date().getFullYear();
    private optionsYear: any[] = [];
    private optionsLabel: any[] = [];
    private optionsStore: any[] = [];
    private optionsStatus: any[] = [
        {key: "", label: "allStatus"},
        {key: Constants.socleBudgetStatus.toValidate, label: Constants.socleBudgetStatus.toValidate, tag: true},
        {key: Constants.socleBudgetStatus.validated, label: Constants.socleBudgetStatus.validated, tag: true},
        {key: Constants.socleBudgetStatus.notValidated, label: Constants.socleBudgetStatus.notValidated, tag: true},
    ];
    private optionsApprovalStatus: any[] = [];
    private countBudgets: number = 0;
    private globalBudget: number = 0;
    private isAllBudgets: boolean = false;
    private validationBudgetFormVisible: boolean = false;
    private budgetSelected: object[] = [];
    private exportDisabled: boolean = false;
    private hierarchyOwners: OptionOwner[] = [];
    private userGuide: Document|null = null;

    @Watch("currentOwnerUuid")
    private refreshList(newUuid: string | null, oldUuid: string | null): void {
        this.buildLabelOptions();
        this.buildStoreOptions();
        this.buildApprovalStatusOptions();
        this.getHierarchyOwners();

        this.currentYear = new Date().getFullYear();

        this.$nextTick(() => {
            if (!this.$el || !this.$el.parentNode) {
                return;
            }

            const newFilters = this.defaultFilters();
            newFilters.ownerUuid = newUuid;

            this.resetSocleFilters(newFilters);
            this.updateFilter(newFilters);

            EventBus.$emit(
                "update-filter",
                _.set(
                    {},
                    "forceReload",
                    !_.get(this.filters, "forceReload", false)
                )
            );
        });
    }

    @Watch("configSocleData") private onConfigSocleDataChanged() {
        this.loadUserGuide();
    }

    private get mixMediaTextHtml(): string {
        if ("mixMediaTextNote" !== _.invoke(this.$options.filters, "trans", "mixMediaTextNote")) {
            return _.invoke(this.$options.filters, "trans", "mixMediaTextNote");
        }
        return "";
    }

    public created(): void {
        if (!this.currentOwnerUuid) {
            return;
        }

        this.$nextTick(() => {
            this.updateFilter(this.filters);
        });
    }

    public mounted() {
        if (this.currentOwnerUuid) {
            this.buildApprovalStatusOptions();
            this.buildLabelOptions();
            this.buildStoreOptions();
            this.getHierarchyOwners();

            if (_.get(this.filters, "ownerUuid", null) !== this.currentOwnerUuid) {
                const newFilters = this.defaultFilters();
                newFilters.ownerUuid = this.currentOwnerUuid;
                this.resetSocleFilters(newFilters);
                this.updateFilter(newFilters);
                EventBus.$emit(
                    "update-filter",
                    _.set(
                        {},
                        "forceReload",
                        !_.get(this.filters, "forceReload", false)
                    )
                );
            }
        }
        for (let i = 2024; i <= this.currentYear + 1; i++) {
            this.optionsYear.push({key: i, label: i});
        }
        EventBus.$on("budget-status-updated", this.refreshListData);
        EventBus.$on("mass-budget-status-updated", this.handleMassBudgetStatusUpdated);
    }

    public refreshListData(): void {
        if (this.currentOwnerUuid) {
            this.buildLabelOptions();
            this.buildStoreOptions();
            this.buildApprovalStatusOptions();
            this.getHierarchyOwners();

            EventBus.$emit(
                "update-filter",
                _.set(
                    {},
                    "forceReload",
                    !_.get(this.filters, "forceReload", false)
                )
            );
        }
    }

    public beforeDestroy(): void {
        EventBus.$off("budget-status-updated", this.refreshListData);
        EventBus.$off("mass-budget-status-updated", this.handleMassBudgetStatusUpdated);
    }

    private updateOwnerFilter(selectedOwner: string): void {
        EventBus.$emit("update-filter", _.set({}, "entityFilter", selectedOwner));
    }

    private updateSelectedChoice(selectedChoice: string|null): void {
        EventBus.$emit("update-filter", _.set({}, "selectedChoice", selectedChoice));
    }

    protected get selectedChoiceOptions(): Node[] {
        return [
            {
                id: "recommended",
                label: _.invoke(this.$options.filters, "trans", "selectSocleSelectedChoice-recommended"),
            },
            {
                id: "modified",
                label: _.invoke(this.$options.filters, "trans", "selectSocleSelectedChoice-modified"),
            },
            {
                id: "canceled",
                label: _.invoke(this.$options.filters, "trans", "selectSocleSelectedChoice-canceled"),
                children: [
                    {
                      id: "other_operations",
                      label: _.invoke(this.$options.filters, "trans", "selectSocleSelectedChoice-other_operations"),
                    },
                    {
                      id: "savings",
                      label: _.invoke(this.$options.filters, "trans", "selectSocleSelectedChoice-savings"),
                    },
                ],
            },
        ];
    }

    private defaultFilters(): Filters {
        return {
            beginDate: "",
            endDate: "",
            storeStatus: "",
            labelFilter: "",
            entityFilter: null,
            status: "",
            ownerUuid: this.currentOwnerUuid,
            year: [this.currentYear],
            selected: true,
            selectedChoice: null,
        };
    }

    private exportCampaign(): void {
        this.exportDisabled = false;
        const exportFilters = _.cloneDeep(this.filters);
        const params = { filters: exportFilters };
        Http.get(
            "/exportcampaignsocle",
            params,
            () => {
                this.$message({
                    message: _.invoke(this.$options.filters, "trans", "socleExportInfo"),
                    type: "warning"
                });
            },
            "errorSocleWorker");
    }

    public updateOperationUuid(uuid: string): void {
        this.currentSocleCampagneUuid = uuid;
    }

    public showSocleBudgetForm(operation: { uuid: string | null }) {
        this.currentSocleCampagneUuid = operation.uuid;
        this.formVisible = true;
    }

    public updateBundleUuid(uuid: string): void {
        this.currentSocleBundleUuid = uuid;
    }

    public showSocleBundleForm(operation: { uuid: string | null }) {
        this.currentSocleBundleUuid = operation.uuid;
        this.formVisible = true;
    }


    public showValidationSocleBudgetForm(
        budgets: any, isAllBudgetOrNot: boolean = false, countBudgets: number = 0, globalBudget: number
    ) {
        this.validationBudgetFormVisible = true;
        this.globalBudget = 0;
        this.budgetSelected = [];
        this.isAllBudgets = false;
        _.set(this, "budgetSelected", budgets);

        if (isAllBudgetOrNot) {
            this.isAllBudgets = true;
            this.countBudgets = countBudgets;
            this.globalBudget = globalBudget;
        }

        _.forEach(this.budgetAvailable, (filteredBudget: any) => {
            _.forEach(filteredBudget.budgetLevers, (budgetLever: any) => {
                this.globalBudget += budgetLever.budget;
            });
            this.globalBudget += _.get(this.configSocleData, "flatFeesAmount", 0);
        });
    }

    public get budgetAvailable(): undefined | any {
        return _.filter(this.budgetSelected, (budget: any) => {
            return moment(budget.campaign.endDate).set("hour", 23).set("minute", 59).isAfter(moment()) &&
                budget.validatedAt == null;
        });
    }

    public get budgetExpired(): undefined | any {
        return _.filter(this.budgetSelected, (budget: any) => {
            return moment(budget.campaign.endDate).set("hour", 23).set("minute", 59).isBefore(moment());
        });
    }

    public get budgetValidated(): undefined | any {
        return _.filter(this.budgetSelected, (budget: any) => {
            return budget.validatedAt !== null && budget.cancelledAt === null;
        });
    }

    private handleMassBudgetStatusUpdated() {
        this.budgetSelected = [];
        this.validationBudgetFormVisible = false;
        this.countBudgets = 0;
    }

    private buildApprovalStatusOptions(): void {
        this.optionsApprovalStatus = [];
        // Récupérer cette donnée depuis le back pour ne pas avoir à se poser la question d'un WF particulier
        Constants.socleApprovalStatus.forEach((value, idx) => {
            this.optionsApprovalStatus.push(
                {
                    key: value,
                    label: value,
                    tag: true
                }
            );
        });
    }

    private buildLabelOptions(): void {
        this.optionsLabel = [];
        const paramsGetOwnerData = {
            fields: [
                "campaign.label",
                "campaign.externalCode",
                "campaign.uuid",
                "campaign.startDate"
            ],
            filters: {
                listLabel: true,
                ownerUuid: this.currentOwnerUuid
            }
        };

        BudgetRepository.get(paramsGetOwnerData).then((data: object[]) => {
            const yearProcessed: any = [];
            _.forEach(data, (line) => {
                let externalCode: boolean | string = _.get(line, "externalCode", false);
                externalCode = !isEmpty(externalCode) ? " (" + externalCode + ")" : "";

                const year = moment(_.get(line, "startDate", false)).format("YYYY");
                const found = _.find(yearProcessed, (option) => option.key === year);

                let optionGroup: any = {
                    key: year,
                    label: year,
                    options: [],
                };

                if (!found) {
                    yearProcessed.push(optionGroup);
                } else {
                    optionGroup = found;
                }

                optionGroup.options.push({
                    key: _.get(line, "uuid", ""),
                    label: _.get(line, "label", "") + externalCode
                });
            });
            this.optionsLabel = yearProcessed;
        });
    }

    private getHierarchyOwners(): void {
        const paramsGetOwnerData = {
            filters: {
                listOwner: true,
                ownerUuid: this.currentOwnerUuid,
            }
        };

        BudgetRepository.get(paramsGetOwnerData).then((data: object[]) => {
            this.hierarchyOwners = data as OptionOwner[];
        });
    }

    private buildStoreOptions(): void {
        this.optionsStore = [];
        const paramsGetOwnerData = {
            fields: [
                "hierarchyOwner.dependentStatus"
            ],
            filters: {
                listDependentStatus: true,
                ownerUuid: this.currentOwnerUuid,
            }
        };
        BudgetRepository.get(paramsGetOwnerData).then((data: object[]) => {
            this.optionsStore.push({key: "", label: "allStoreStatus"});
            _.forEach(data, (line) => {
                this.optionsStore.push({
                    key: _.get(line, "dependentStatus"),
                    label: _.get(line, "dependentStatus")
                });
            });
        });
    }

    private loadUserGuide(): void {
        this.userGuide = null;
        const docComment = _.get(this.configSocleData, "lightMode", false) ? "socle_light_user_guide" : "socle_user_guide";

        const paramsGetOwnerData = {
            fields: [
                "link",
                "clientOriginalFileName",
            ],
            filters: {
                comment: docComment,
                type: "user_guide",
                owner: this.currentOwnerUuid,
            }
        };
        FileRepository.get(paramsGetOwnerData).then((data: object[]) => {
            this.userGuide = data[0] as Document;
        });
    }

    public downloadUserGuide(): void {
        this.download(this.userGuide as Document);
    }

    public download(documentDownloaded: Document) {
        FileRepository.download(documentDownloaded);
    }
}
